import React from "react";
import { Link } from "react-router-dom";
import { authors as allAuthors } from "../data/authors";

const authorNames = (slugs) =>
  slugs
    .map((s) => allAuthors.find((a) => a.slug === s)?.name)
    .filter(Boolean)
    .join(" & ");

export const BookCard = ({ book, index = 0, size = "md" }) => {
  const dimensions =
    size === "lg"
      ? "aspect-[2/3] max-w-[340px]"
      : size === "sm"
      ? "aspect-[2/3] max-w-[200px]"
      : "aspect-[2/3] max-w-[280px]";

  return (
    <Link
      to={`/books/${book.slug}`}
      data-testid={`book-card-${book.slug}`}
      className="group block opacity-0 animate-fade-up"
      style={{ animationDelay: `${index * 90}ms` }}
    >
      <div
        className={`relative w-full ${dimensions} overflow-hidden bg-ivory-soft`}
        style={{ backgroundColor: book.palette?.bg || "#F3EFE6" }}
      >
        <img
          src={book.cover}
          alt={book.coverAlt}
          loading="lazy"
          className="w-full h-full object-contain object-center transform duration-700 group-hover:scale-[1.04]"
        />
      </div>
      <div className="mt-5 space-y-1.5">
        <p className="text-[10px] uppercase tracking-[0.28em] text-crimson/80">
          {book.imprint}
        </p>
        <h3 className="font-editorial text-xl md:text-2xl leading-tight text-ink group-hover:text-crimson transition-colors duration-500 text-balance">
          {book.title}
        </h3>
        <p className="text-sm text-ink-muted italic">{book.subtitle}</p>
        <p className="text-xs uppercase tracking-[0.18em] text-ink-muted pt-2">
          {authorNames(book.authors)}
        </p>
      </div>
    </Link>
  );
};

export default BookCard;
